module.exports = __webpack_public_path__ + "img/0xed28a457a5a76596ac48d87c0f577020f6ea1c4c.48cd1e9e.png";